import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ClientLogsService } from '../../core/services/client-logs.service';
import { environment } from '../../../environments/environment';
import { createUuid } from '../utils/uuid.util';

export const logsConnectivityInterceptor: HttpInterceptorFn = (request, next) => {
  // Do not observe the logger's own uploads or third-party/static requests.
  if (!request.url.startsWith(`${environment.apiEndpoint}/`) || request.url.includes('/logs/batch')) return next(request);
  const logs = inject(ClientLogsService);
  const context = logs.captureContext();
  const preferencesSync = request.method === 'PATCH' && request.url === `${environment.apiEndpoint}/users/me/preferences`;
  const operationId = preferencesSync ? createUuid() : undefined;
  return next(request).pipe(tap({
    next: response => { if (response instanceof HttpResponse) logs.observeBackend(response.status, context); },
    error: error => {
      if (!(error instanceof HttpErrorResponse)) return;
      logs.observeBackend(error.status, context);
      if (context && operationId && ![401, 403, 429].includes(error.status)) {
        logs.record(error.status === 409 ? 'SYNC_CONFLICT' : 'SYNC_FAILED',
          { operationId, sequence: 1, resourceType: 'settings' }, error.status === 409 ? 'CONFLICT' : 'UNKNOWN', context);
      }
    }
  }));
};
